import { render, staticRenderFns } from "./LightUgTableHeader.vue?vue&type=template&id=7fd185b5&scoped=true"
import script from "./LightUgTableHeader.vue?vue&type=script&lang=ts"
export * from "./LightUgTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./LightUgTableHeader.vue?vue&type=style&index=0&id=7fd185b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd185b5",
  null
  
)

export default component.exports